<div class="info-panel">
    @if (!noIcon || header || dismissible) {
        <div class="title-row">
            @if (!noIcon) {
                <span class="icon-wrapper">
                    @if (icon) {
                        <ng-content select="[mgdInfoPanelIcon]"></ng-content>
                    } @else {
                        <mat-icon class="mat-icon-default" aria-hidden="true">{{ defaultIcon }}</mat-icon>
                    }
                </span>
            }
            @if (header) {
                <span class="header-wrapper">
                    <ng-content select="[mgdInfoPanelHeader]"></ng-content>
                </span>
            }
            @if (dismissible) {
                <span class="dismiss-wrapper">
                    <button [id]="dismissButtonId" class="mat-dismiss-icon-button" mat-icon-button mgdButton aria-label="Dismiss" (click)="onDismissClick()">
                        <mat-icon>close</mat-icon>
                    </button>
                </span>
            }
        </div>
    }
    <div class="body-wrapper">
        <ng-content></ng-content>
    </div>
</div>
